import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, VERSION, ViewChild, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, Validators, ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService, NgxSpinnerModule  } from 'ngx-spinner';
import { LocalStorageService } from 'ngx-webstorage';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { ClaimantService } from '../../services/claimant/claimant.service';
import { ClaimantsModel } from '../../models/claimantsmodel';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha-2';


@Component({
  selector: 'app-opt-out',
  templateUrl: './opt-out.html',
  styleUrls: ['./opt-out.css'],
  imports: [ReactiveFormsModule, CommonModule, NgxTrimDirectiveModule, NgxMaskDirective, NgxSpinnerModule, RecaptchaModule, RecaptchaFormsModule],
  providers: [provideNgxMask()], // Provide at the component level
})
export class OptOut implements OnInit {
  @ViewChild('listofFiles') tableRef: ElementRef;
  @ViewChild('fileInput') fileInput: ElementRef;

  optOutForm: FormGroup;
  allStates: any = [];
  allCountries: any = [];
  allCompanyHealthTypes: any = [];
  allRelationshipTypes: any = [];
  showDivOptSectionA: boolean = false;
  showDivOptSectionB: boolean = false;
  showDivOtherHealthType: boolean = false;
  showDivOtherRelationshipType: boolean = false;
  submitted = false;
  clicked = false;
  supportingDocuments: File[] = [];
  cmList: any = [];
  cmPAList: any = [];
  submittedClaim: ClaimantsModel;
  response: string | undefined;

  constructor(private fb: FormBuilder,
    private httpClient: HttpClient,
    private storage: LocalStorageService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private tppClaimantService: ClaimantService) { }


  ngOnInit() {
    this.loadAllStates();
    this.optOutForm = this.fb.group({
      optOutAcknowledgement: [false],
      brokerDealerName: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      noticeId: ["", Validators.compose([Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],
      emailAddress: ['', Validators.compose([Validators.maxLength(255), Validators.pattern("[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$")])],
      street1: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      city: ['', Validators.compose([Validators.required, Validators.maxLength(40), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],
      state: ['', Validators.compose([Validators.required])],
      zip: ['', Validators.compose([Validators.required, Validators.pattern("^[0-9]{5}(?:-[0-9]{4})?$")])],
      phone1: ['', Validators.compose([Validators.maxLength(10), Validators.minLength(10), Validators.pattern("^[0-9]+$")])],   
      signature: ['', Validators.compose([Validators.required, Validators.maxLength(50), Validators.minLength(2), Validators.pattern("^[a-zA-Z0-9 .\\[\\]/#&'()-]+$")])],    
      googleRecaptchaToken: ['', Validators.compose([Validators.required])],
    })
  }

  loadAllStates() {
    this.httpClient.get("assets/States.json").subscribe(data => {
      /* console.log(data);*/
      this.allStates = data;
    })
  }

  resolved(captchaResponse: string) {
    this.response = captchaResponse;
  }

  get f() { return this.optOutForm.controls; }

  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.optOutForm.invalid) {
      return;
    }

    this.clicked = true;
    const claimant = this.optOutForm.value;

    claimant.FormType = "Opt-Out Form"

    this.spinner.show();

    console.log(claimant);
    this.CreateClaimant(claimant);
  }

  CreateClaimant(claimant: ClaimantsModel) {
    this.tppClaimantService.createClaimant(claimant).subscribe({
      next: (res) => {
        this.storage.store('claimant', res);
        this.optOutForm.reset();
        this.spinner.hide();
        this.router.navigate(['/complete']);
      },
      error: err => {
        this.spinner.hide();
        console.group('Claimant submission failed');
        console.log('Status:', err.status);
        console.log('Error:', err.error);
        console.groupEnd();
      }
    });
  }
}
